// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YQ6QW","link":"styles_link__d0KUL"};